export const itGovernanceAndCompliance = {
  id: 6,
  title: "IT Governance and Compliance",
  activityId: [6, 7],
  startDate: '2023-01-01',
  endDate: '2025-02-28',
  description: "Improved IT compliance by 67% via governance initiatives and a KPI dashboard for automated transparency.",
  categorizedSkills: {
    profession: [
      { name: "IT Governance", weight: 1 },
      { name: "GDPR", weight: 0.9 },
      { name: "Risk Management", weight: 0.8 },
      { name: "Audit Management", weight: 0.7 }
    ],
    lead: [
      { name: "Project Management", weight: 1 },
      { name: "Team Leadership", weight: 0.8 },
      { name: "Strategic Planning", weight: 0.8 }
    ],
    tools: [
      { name: "LeanIX", weight: 1 },
      { name: "Confluence", weight: 0.8 },
      { name: "COBIT", weight: 0.7 },
      { name: "ITIL", weight: 0.7 }
    ],
    language: []
  },
  goal: "Maintain IT compliance and establish automated transparency through governance initiatives",
  detailsFile: "it-governance-and-compliance.md", // Reference to markdown file
  metrics: [
    "67% improvement in IT compliance",
    "Led 3 person IT-Governance Team"
  ],
  role: "Local Compliance Officer",
  teamSize: "3",
  git: "inner source",
  link: "inner source",
  isProfessional: true,
  isVisible: true
};
